export class BingMapsLocationHttpResponse {
  authenticationResultCode: string;
  brandLogoUri: string;
  copyright: string;
  resourceSets: Array<BingMapsResourceSets>;
  statusCode: number;
  statusDescription: string;
  traceId: string;
}

export class BingMapsResourceSets {
  resourceSets: number;
  resources: Array<BingMapsLocationData>;
}

export class BingMapsLocationData {
  __type: string;
  bbox: Array<number>;
  name: string;
  point: BingMapsPoint;
  address: BingMapsAddress;
  confidence: 'High' | 'Medium' | 'Low';
  entityType: string;
  geocodePoints: Array<BingMapsGeocodePoint>;
  matchCodes: Array<'Good' | 'Ambiguous' | 'UpHierarchy'>;
}

export class BingMapsPoint {
  type: string;
  coordinates: Array<number>;
}

export class BingMapsAddress {
  adminDistrict: string;
  adminDistrict2: string;
  countryRegion: string;
  formattedAddress: string;
  locality: string;
  neighborhood: string;
  landmark: string;
}

export class BingMapsGeocodePoint {
  type: string;
  coordinates: Array<number>;
  calculationMethod: string;
  usageTypes: Array<string>;
}
